import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { activateModal } from '../../store/actions';
import { ViewerSecondaryColorUserStyle } from '../UserCustomization';

const domStyle = ['color', 'borderColor'];

export class RemoveAllActionComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.relayRemoveAll = this.relayRemoveAll.bind(this);
  }

  relayRemoveAll() {
    const { handleClick, showFoldersModal, ...props } = this.props;

    handleClick(props);
    showFoldersModal();
  }

  render() {
    return (
      <ViewerSecondaryColorUserStyle domStyle={domStyle}>
        <button
          type="button"
          className="btn--link"
          onClick={this.relayRemoveAll}
        >
          Remove All
        </button>
      </ViewerSecondaryColorUserStyle>
    );
  }
}

RemoveAllActionComponent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  showFoldersModal: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    showFoldersModal() { dispatch(activateModal('folders')); },
  };
}

export default connect(null, mapDispatchToProps)(RemoveAllActionComponent);



// WEBPACK FOOTER //
// ./src/components/Favorites/RemoveAllAction.js